export default {
  trackView: function() {},
  sendEvent: function() {},
};
